import { render, staticRenderFns } from "./DetailByInmo.vue?vue&type=template&id=0f72ee97"
import script from "./DetailByInmo.vue?vue&type=script&lang=js"
export * from "./DetailByInmo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports